import { DrawRequestResp } from "../../../types/draw-request";
import { UserManagement } from "../../../types/user-management";

export const canVoid = (drawRequest: DrawRequestResp | undefined, userExtraInfo: UserManagement | undefined) => {
    if (!drawRequest || !userExtraInfo) return false

    if (drawRequest.isDraft) return false;

    const accountingApprovalStatus = drawRequest.accountingApprovalStatus?.toLowerCase();
    if (accountingApprovalStatus === "approved" || accountingApprovalStatus === "denied") return false;

    const approvalStatus = drawRequest?.approvalStatus?.toLowerCase();

    if (approvalStatus === "completed" || approvalStatus === "rejected" || approvalStatus === "voided") return false;

    return drawRequest.initiatorId === userExtraInfo?.id?.toString();
};